export default {
	showuser(state){
		return state.info.username
	},
  showvip(state){
  	return state.info.vip
  }
}
